import { mapKeys, pickBy } from 'lodash';
import { useMemo } from 'react';

/**
 * @param {Record<string, string>} classes
 * @param {string} prefix
 * @returns {Record<string, string>}
 */
export default function useStylesSubset(classes, prefix) {
    return useMemo(() => {
        let out = pickBy(classes, (value, key) => key.startsWith(prefix));

        out = mapKeys(out, (value, key) => {
            key = key.substring(prefix.length);

            const firstChar = key.substring(0, 1).toLowerCase();
            const rest = key.substring(1);

            return `${firstChar}${rest}`;
        });

        return out;
    }, [classes, prefix]);
}